import React from "react";
import "../Hero.scss";
import heroPicture from "../../images/hero-picture.png";
import start from "../../images/stars.svg";
import hero1 from "../../images/hero1.png";
import hero2 from "../../images/hero2.svg";
import hero3 from "../../images/hero3.svg";
const HeroComponent = () => {
  return (
    <div id="home" className="MainContainer">
      <div className="heroContainer">
        <div className="leftSection">
          <h1 className="agencyTitile">your agency.</h1>
          <h1 className="boxTitle">in a box</h1>
          <p className="patagraphHeroH">
            All of your work in a one place. And much more
          </p>
          <input
            className="EnterYourEmail"
            placeholder="Enter your email address"
          />
          <div className="SignUpHero">
            <a href="#" className="signUpButton">
              Sign Up
            </a>
            <p className="signUpParagraph">
              AND BE PART OF <br /> THE CLOSED BETA
            </p>
          </div>
          <div className="rating">
            <img className="ratingIMG" src={start} alt="stars" />
          </div>
          <div className="companiesSVGs">
            <img className="companyIMG" src={hero1} alt="CROWD" />
            <img className="companyIMG" src={hero2} alt="TrustPilot" />
            <img className="companyIMG" src={hero3} alt="Capterra" />
          </div>
        </div>
        <div className="rightSection">
          <img className="rightImage" src={heroPicture} />
        </div>
      </div>
    </div>
  );
};

export default HeroComponent;
